/** Les dates et les durees, et la facon de les dire. */
export const temps = {
  ilYa: {
    instant: "à l'instant",
    minutes: (n: number) => `il y a ${n} min`,
    heures: (n: number) => `il y a ${n} h`,
    jours: (n: number) => `il y a ${n} j`,
    semaines: (n: number) => `il y a ${n} sem.`,
    mois: (n: number) => `il y a ${n} mois`,
    ans: (n: number) => `il y a ${n} an${n > 1 ? 's' : ''}`,
  },
  hier: 'hier',
  Hier: 'Hier',
  aujourdhui: "Aujourd'hui",
  heure: {
    /** "17h", "17h30" : l'ecriture francaise. */
    pleine: (h: number) => `${h}h`,
    avecMinutes: (h: number, minutes: string) => `${h}h${minutes}`,
  },
  masqueDate: 'JJ / MM / AAAA',
  aujourdhuiMin: "aujourd'hui",
};
